




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface SocleBundle {
    hierarchyOwner: {
        fullName: string;
    };
}

@Component({ components: { SimpleText } })
export default class HierarchyFullName extends Vue {
    @Prop( { default: null }) public bundle !: SocleBundle;

    public static getNeededFields(): string[] {
        return [
            "bundle.hierarchyOwner.fullName",
        ];
    }
}
